import React from "react";
import CloseTag from "assets/img/closeTag.svg";
import isObject from "helpers/isObject";

const Tags = ({ tags, border, onRemove }) => {
  return (
    <React.Fragment>
      <div
        id="Tags"
        className={`pb-0 mt-2 ${
          border || typeof border === "undefined" ? "p-2 border-2" : ""
        }`}
      >
        {(tags || []).map((tag) => {
          return (
            <div
              key={isObject(tag) ? tag.value : tag}
              className="flex items-center float-left tag px-3 py-1 mr-2 mb-2"
            >
              <div className="font-medium">
                {isObject(tag) ? tag.name : tag}
              </div>
              {onRemove && (
                <div className="ml-2 pointer" onClick={() => onRemove(tag)}>
                  <img src={CloseTag} />
                </div>
              )}
            </div>
          );
        })}
        <div className="clear-both" />
      </div>
    </React.Fragment>
  );
};

export default Tags;
